import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


const CategoryKey = ({ hasEras, activeEra, erasBySlug, categories, categoryKey }) => {
  const catList = hasEras ? erasBySlug[activeEra].categories : categories;
  const catObj = hasEras ? erasBySlug[activeEra].categoryKey : categoryKey;
  if (!catList || catList.length === 0) {
    return null;
  }
  const key = catList.map(name => ([name, catObj[name]]));
  if ('default' in catObj) {
    key.unshift(['Uncategorized', catObj.default]);
  }

  // TODO: i18n hardcoded string
  return (
    <div className="d-flex justify-content-center">
      {key.map(([name, { icon: Icon, fill }]) => (
        <div key={name} className="label py-2 px-3">
          <Icon size={14} fill={fill} style={{ position: 'relative', top: '2px' }} />
          <span className="pl-2">{name} Event</span>
        </div>
      ))}
    </div>
  );
};

CategoryKey.propTypes = {
  titleId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ titles }, ownProps) => ({
  ...titles[ownProps.titleId],
});

export default connect(mapStateToProps)(CategoryKey);



// WEBPACK FOOTER //
// ./src/components/Timeline/CategoryKey.js